import React, { useState, useRef } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import s from './Header.module.css';
import logo from './images/Logo.svg';

const menuItems = [
    { label: 'Brand Analytics', to: '/brand-analytics' },
    { label: 'Version Control', to: '/version-control' },
    { label: 'Creativity', to: '/creativity' },
    { label: 'Approval Process', to: '/approval-process' },
    { label: 'Teamwork', to: '/teamwork' },
];

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const iconRef = useRef(null);
    const navigate = useNavigate();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const handleIconClick = (e: React.MouseEvent) => {
        e.preventDefault();
        setMenuOpen((open) => !open);
    };

    const handleMenuItemClick = (path: string) => {
        setMenuOpen(false);
        navigate(path);
    };

    const handleMenuClick = (e: React.MouseEvent) => {
        e.stopPropagation();
    };

    const scrollToPricing = (e: React.MouseEvent) => {
        e.preventDefault();
        const pricingSection = document.getElementById('pricing');
        if (pricingSection) {
            pricingSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    React.useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (iconRef.current && !(iconRef.current as any).contains(event.target)) {
                setMenuOpen(false);
            }
        };
        if (menuOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [menuOpen]);

    return (
        <header className={s.header}>
            <div className={s.logoContainer}>
                {/* <button
                    className={s.burger}
                    aria-label="Open menu"
                    aria-controls="mobile-menu"
                    aria-expanded={mobileMenuOpen}
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                    type="button"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="14"
                        viewBox="0 0 20 14"
                        fill="none"
                    >
                        <path
                            d="M19.375 1.25H0.625C0.45924 1.25 0.300269 1.18415 0.183058 1.06694C0.065848 0.949731 0 0.79076 0 0.625C0 0.45924 0.065848 0.300269 0.183058 0.183058C0.300269 0.0658481 0.45924 0 0.625 0H19.375C19.5408 0 19.6997 0.0658481 19.8169 0.183058C19.9342 0.300269 20 0.45924 20 0.625C20 0.79076 19.9342 0.949731 19.8169 1.06694C19.6997 1.18415 19.5408 1.25 19.375 1.25Z"
                            fill="black"
                        />
                        <path
                            d="M19.375 7.5H0.625C0.45924 7.5 0.300269 7.43415 0.183058 7.31694C0.065848 7.19973 0 7.04076 0 6.875C0 6.70924 0.065848 6.55027 0.183058 6.43306C0.300269 6.31585 0.45924 6.25 0.625 6.25H19.375C19.5408 6.25 19.6997 6.31585 19.8169 6.43306C19.9342 6.55027 20 6.70924 20 6.875C20 7.04076 19.9342 7.19973 19.8169 7.31694C19.6997 7.43415 19.5408 7.5 19.375 7.5Z"
                            fill="black"
                        />
                        <path
                            d="M19.375 13.75H0.625C0.45924 13.75 0.300269 13.6842 0.183058 13.5669C0.065848 13.4497 0 13.2908 0 13.125C0 12.9592 0.065848 12.8003 0.183058 12.6831C0.300269 12.5658 0.45924 12.5 0.625 12.5H19.375C19.5408 12.5 19.6997 12.5658 19.8169 12.6831C19.9342 12.8003 20 12.9592 20 13.125C20 13.2908 19.9342 13.4497 19.8169 13.5669C19.6997 13.6842 19.5408 13.75 19.375 13.75Z"
                            fill="black"
                        />
                    </svg>
                </button> */}
                <img
                    src={logo}
                    alt="SimpleeCreate Logo"
                    className={s.logoImg}
                    onClick={() => navigate('/')}
                />
                <h1 className={s.logoText}>SimpleeCreate</h1>
            </div>
            {/* 
            <nav
                id="mobile-menu"
                className={`${s.mobileMenu} ${mobileMenuOpen ? s.open : ''}`}
                aria-label="Mobile navigation"
                role="navigation"
            >
                <button
                    className={s.close}
                    aria-label="Close menu"
                    onClick={() => setMobileMenuOpen(false)}
                    type="button"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="18"
                        viewBox="0 0 15 18"
                        fill="none"
                    >
                        <path
                            d="M1.4219 17.1259C1.05415 17.1493 0.692482 17.0156 0.413159 16.7532C-0.13772 16.1476 -0.13772 15.1694 0.413159 14.5637L12.4756 1.3802C13.0486 0.794231 13.9476 0.826805 14.4838 1.45302C14.9686 2.0193 14.9969 2.88968 14.5499 3.49206L2.41642 16.7532C2.1407 17.0119 1.78484 17.1452 1.4219 17.1259Z"
                            fill="black"
                        />
                        <path
                            d="M13.47 17.126C13.0973 17.1242 12.74 16.9625 12.4754 16.6757L0.412924 3.49208C-0.097437 2.84071 -0.0280508 1.86044 0.567931 1.30259C1.09986 0.804734 1.88435 0.804734 2.41623 1.30259L14.5497 14.4861C15.1226 15.0722 15.1522 16.0549 14.6159 16.681C14.5946 16.7059 14.5725 16.73 14.5497 16.7533C14.2526 17.0357 13.8616 17.1706 13.47 17.126Z"
                            fill="black"
                        />
                    </svg>
                </button>
                <ul className={s.list}>
                    <li>
                        <Link to="/brand-analytics" className={s.listItem}>
                            Brand Analytics
                        </Link>
                    </li>
                    <li>
                        <Link to="/version-control" className={s.listItem}>
                            Version Control
                        </Link>
                    </li>
                    <li>
                        <Link to="/creativity" className={s.listItem}>
                            Creativity
                        </Link>
                    </li>
                    <li>
                        <Link to="/approval-process" className={s.listItem}>
                            Approval Process
                        </Link>
                    </li>
                    <li>
                        <Link to="/teamwork" className={s.listItem}>
                            Teamwork
                        </Link>
                    </li>
                    <li>
                        <Link to="/about" className={s.listItem}>
                            Why Choose Simplee
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="/contact"
                            className={s.button}
                            style={{ width: '60%', margin: '20px auto 0 auto' }}
                        >
                            Request Demo
                        </Link>
                    </li>
                </ul>
            </nav> */}
            <div className={s.headerRight}>
                <nav className={s.nav} aria-label="Main navigation" role="navigation">
                    <ul className={s.navList}>
                        {/* <li>
                            <Link to="/" className={s.navLink}>
                                Home
                            </Link>
                        </li>
                        <li>
                            <Link to="/about" className={s.navLink}>
                                Why choose simplee
                            </Link>
                        </li> */}
                        <li style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                            {/* <Link to="/features" className={s.navLink} style={{ marginRight: 4 }}>
                                Features
                            </Link> */}
                            {/* <button
                                ref={iconRef}
                                onClick={handleIconClick}
                                className={s.dropdownIcon}
                                style={{
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    background: 'none',
                                    border: 'none',
                                    padding: 0,
                                }}
                                aria-haspopup="true"
                                aria-expanded={menuOpen}
                                aria-label="Open solutions menu"
                                type="button"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="26"
                                    height="26"
                                    viewBox="0 0 26 26"
                                    fill="none"
                                >
                                    <path
                                        d="M13.0001 17.8751C12.7923 17.8751 12.5843 17.7956 12.4256 17.637L4.30061 9.51199C3.98313 9.1945 3.98313 8.68039 4.30061 8.36311C4.6181 8.04583 5.13221 8.04563 5.44949 8.36311L13.0001 15.9137L20.5506 8.36311C20.8681 8.04563 21.3822 8.04563 21.6995 8.36311C22.0168 8.6806 22.017 9.19471 21.6995 9.51199L13.5745 17.637C13.4158 17.7956 13.2078 17.8751 13.0001 17.8751Z"
                                        fill="black"
                                    />
                                </svg>
                            </button> */}
                            {menuOpen && (
                                <ul
                                    className={s.dropdownMenu}
                                    style={{
                                        position: 'absolute',
                                        top: '100%',
                                        left: 0,
                                        zIndex: 1000,
                                        marginTop: '5px',
                                        background: '#fff',
                                        borderRadius: '16px',
                                        boxShadow: '0 4px 20px 0 rgba(0, 0, 0, 0.10)',
                                        padding: '4px',
                                    }}
                                    onClick={handleMenuClick}
                                    role="menu"
                                    aria-label="Solutions submenu"
                                >
                                    {menuItems.map((item) => (
                                        <li key={item.to} role="none">
                                            <button
                                                role="menuitem"
                                                onMouseDown={(e) => {
                                                    e.stopPropagation();
                                                    e.preventDefault();
                                                    handleMenuItemClick(item.to);
                                                }}
                                                style={{
                                                    border: 'none',
                                                    background: 'none',
                                                    width: '100%',
                                                    textAlign: 'left',
                                                    cursor: 'pointer',
                                                    padding: '10px 20px',
                                                    fontSize: '14px',
                                                    fontFamily: 'Figtree',
                                                    color: '#7F7F7F',
                                                    transition: 'background 0.2s, color 0.2s',
                                                    borderRadius: '16px',
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.background =
                                                        'rgba(255, 53, 137, 0.15)';
                                                    e.currentTarget.style.color = '#FF3589';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.background = '#fff';
                                                    e.currentTarget.style.color = '#121212';
                                                }}
                                                tabIndex={0}
                                                aria-label={item.label}
                                                type="button"
                                            >
                                                {item.label}
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                        {/* <li>
                            <button onClick={scrollToPricing} className={s.navLink} type="button">
                                Pricing
                            </button>
                        </li> */}
                        <li>
                            <Link to="/contact" className={s.navLink}>
                                Contact us
                            </Link>
                        </li>
                    </ul>
                </nav>

                <button onClick={() => navigate('/contact')} className={s.button} type="button">
                    Request Early Access
                </button>
            </div>
        </header>
    );
};

export default Header;
